export default {
  name: "StarHalf",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  path: {
    "fill-rule": "evenodd",
    d:
      "M30.13 13.76c.71-.62.33-1.8-.6-1.87l-8.42-.68c-.39-.03-.74-.28-.89-.65l-3.24-7.88a1.05 1.05 0 0 0-1.95 0l-3.24 7.88c-.15.37-.5.62-.89.65l-8.42.68c-.94.08-1.31 1.26-.6 1.87l6.41 5.55c.3.26.43.67.34 1.06l-1.96 8.3c-.22.92.78 1.65 1.58 1.16l7.21-4.45c.34-.21.76-.21 1.1 0l7.21 4.45c.8.49 1.79-.23 1.58-1.16l-1.96-8.3c-.09-.39.04-.8.34-1.06l6.4-5.55zm-8.81 7.1 1.37 5.81-5.04-3.11c-.51-.31-1.08-.47-1.65-.47V5.86l2.27 5.51a3.181 3.181 0 0 0 2.67 1.96l5.89.48-4.49 3.88c-.9.78-1.29 2.01-1.02 3.17z",
    "clip-rule": "evenodd",
  },
}
